import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {  getToolTypeList } from "../../Thunks/HeyTraderThunks";
import { ToolType } from "../../Types/HeyTraderTypes/Tools/ToolType";

interface ToolTypeSliceState {
    loader: boolean; // for refres pages and inital loadings
    toolTypes: ToolType[];
    errorDisplay: string | null;
}

// set inital valus
const initialState : ToolTypeSliceState = {
    loader: false,
    toolTypes: [],
    errorDisplay: '',

}

// set state valu for api response

const toolTypeSlice = createSlice ({
    name: 'toolTypes',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getToolTypeList.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getToolTypeList.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getToolTypeList.fulfilled, (state, action: PayloadAction<ToolType[]>) => {
                    state.loader = false;
                    state.toolTypes = action.payload;
                  })
    }
})

export const {} = toolTypeSlice.actions
export default toolTypeSlice.reducer

